import { cloneElement, createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";
import { useHandleClick } from "../../hooks/useClickHandler";

import "../styles/Modal.css";

const ModalContext = createContext();

function Modal({ children }) {
  const [openName, setOpenName] = useState("");

  const close = () => setOpenName("");
  const open = setOpenName;

  return <ModalContext.Provider value={{ openName, close, open }}>{children}</ModalContext.Provider>;
}

function Open({ children, opens, onSubmit }) {
  const { open } = useContext(ModalContext);

  return cloneElement(children, {
    onClick: () => {
      open(opens);
      if (onSubmit) {
        onSubmit();
      }
    },
  });
}

function Window({ children, name }) {
  const { openName, close } = useContext(ModalContext);
  const ref = useHandleClick(close);

  if (name !== openName) return null;

  return createPortal(
    <div className="modal-overlay">
      <div ref={ref} className="styled-modal">
        <button className="btn-modal" onClick={close}>
          X
        </button>
        <div>{cloneElement(children, { onCloseModal: close })}</div>
      </div>
    </div>,
    document.body
  );
}

Modal.Open = Open;
Modal.Window = Window;

export default Modal;
